module.exports = __webpack_public_path__ + "img/nouveautes.209e1e7.png";